import { useEffect } from "react";
import { useToast } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

interface LogoutRequiredDetail {
    reason?: string;
}

/**
 * AuthListener Component.
 *
 * Listens for global authentication events and displays the appropriate toasts.
 * This component renders nothing; it only handles events.
 */
const AuthListener = (): null => {
    const toast = useToast();
    const navigate = useNavigate();

    useEffect(() => {
        // Listen for the "logout required" event
        const handleLogoutRequired = (event: Event): void => {
            const { reason } = (event as CustomEvent<LogoutRequiredDetail>).detail || {};

            toast({
                title: "Session expirée",
                description: reason || "Votre session a expiré. Veuillez vous reconnecter.",
                status: "warning",
                duration: 6000,
                isClosable: true,
                position: "top",
            });

            // Redirect to the login page after a brief delay so the toast is visible.
            setTimeout(() => {
                navigate("/login");
            }, 1000);
        };

        globalThis.addEventListener('auth:logout-required', handleLogoutRequired);

        return () => {
            globalThis.removeEventListener('auth:logout-required', handleLogoutRequired);
        };
    }, [toast, navigate]);

    return null; // This component renders nothing
};

export default AuthListener;
